(function () {
  function modelKey(label) {
    var value = String(label || '').trim().toLowerCase();

    if (value.indexOf('edelstahl') !== -1 || value.indexOf('pro') !== -1) {
      return 'edelstahl-pro';
    }

    if (value.indexOf('2.0') !== -1 || value.indexOf('2,0') !== -1) {
      return '2-0';
    }

    return 'classic';
  }

  function feederCount(value) {
    value = String(value || '').trim().toLowerCase();
    return /(^|\D)2(\D|$)/.test(value) ? '2' : '1';
  }

  function modelAlt(label) {
    var key = modelKey(label);
    if (key === 'edelstahl-pro') return 'Edelstahl Pro';
    if (key === '2-0') return 'Katzenbrunnen 2.0';
    return 'Kabellos Classic';
  }

  function readCurrentState(root) {
    var selector = document.querySelector('[data-catzy-bundle]');
    return {
      group: (selector && selector.dataset.bundleGroup) || root.dataset.bundleGroup || '',
      modelLabel: (selector && selector.dataset.selectedModelLabel) || root.dataset.initialModel || 'classic',
      variantKey: (selector && selector.dataset.selectedVariantKey) || root.dataset.initialFeeder || '1'
    };
  }

  function initMedia(root) {
    if (!root || root.dataset.bundleMediaInitialized === 'true') return;
    root.dataset.bundleMediaInitialized = 'true';

    var image = root.querySelector('[data-bundle-hero-image]');
    var mapNode = root.querySelector('[data-bundle-hero-map]');
    if (!image || !mapNode) return;

    var map = {};
    try {
      map = JSON.parse(mapNode.textContent);
    } catch (error) {
      console.warn('Catzyfied bundle hero map could not be parsed.', error);
      return;
    }

    var group = root.dataset.bundleGroup || '';

    function update(state) {
      state = state || {};
      if (state.group && group && state.group !== group) return;

      var mKey = group === 'edelstahl'
        ? 'edelstahl-pro'
        : modelKey(state.modelLabel);

      var fCount = group === 'edelstahl'
        ? '1'
        : feederCount(state.variantKey);

      var key = mKey + '|' + fCount;
      var url = map[key];

      if (!url && group === 'edelstahl') url = map['edelstahl-pro|1'];
      if (!url) return;

      if (image.getAttribute('src') !== url) {
        image.classList.add('is-changing');

        var preload = new Image();
        preload.onload = function () {
          image.setAttribute('src', url);
          image.setAttribute(
            'alt',
            'Catzyfied Set – ' + modelAlt(state.modelLabel) +
              (group === 'edelstahl' ? '' : ' – ' + fCount + (fCount === '1' ? ' Futternapf' : ' Futteraufsätze'))
          );

          requestAnimationFrame(function () {
            image.classList.remove('is-changing');
          });
        };
        preload.src = url;
      }
    }

    document.addEventListener('catzy:bundle-change', function (event) {
      update(event.detail || {});
    });

    update(readCurrentState(root));
  }

  function initAll() {
    document.querySelectorAll('[data-catzy-bundle-media]').forEach(initMedia);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
